export default "__VITE_ASSET__c1f79e3b__"